<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
		<path fill="currentColor" d="M6.21 14.339L-.007 8.22l3.084-3.035L6.21 8.268l6.713-6.607l3.084 3.035zM1.686 8.22l4.524 4.453l8.104-7.976l-1.391-1.369L6.21 9.935L3.077 6.852z" />
	</svg>
</template>
